// src/utils/colors.ts

// Deterministic categorical color mapping by series name

const CATEGORICAL_PALETTE = [
  '#3b82f6', // blue-500
  '#22c55e', // green-500
  '#f59e0b', // amber-500
  '#ef4444', // red-500
  '#a78bfa', // violet-400
  '#ec4899', // pink-500
  '#14b8a6', // teal-500
  '#f97316', // orange-500
  '#8b5cf6', // violet-500
  '#06b6d4', // cyan-500
  '#10b981', // emerald-500
  '#6366f1', // indigo-500
  '#84cc16', // lime-500
  '#f43f5e', // rose-500
  '#0ea5e9', // sky-500
  '#eab308', // yellow-500
  '#d946ef', // fuchsia-500
];

function djb2Hash(input: string): number {
  let hash = 5381;
  for (let i = 0; i < input.length; i++) {
    // hash * 33 + char
    hash = ((hash << 5) + hash) + input.charCodeAt(i);
    // Force 32-bit integer
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getSeriesColorForName(name: string | undefined | null): string {
  const DEFAULT_COLOR = '#3b82f6';
  const key = String(name ?? '').trim().toLowerCase();
  if (!key) return DEFAULT_COLOR;
  const paletteSize = CATEGORICAL_PALETTE.length || 1;
  const idx = djb2Hash(key) % paletteSize;
  const picked = CATEGORICAL_PALETTE[idx];
  return picked ?? DEFAULT_COLOR;
}

export function hexToRgba(hex: string, alpha: number): string {
  const a = Math.max(0, Math.min(1, alpha));
  const normalized = String(hex || '').replace('#', '');
  let rHex = '00';
  let gHex = '00';
  let bHex = '00';

  if (/^[0-9a-fA-F]{3}$/.test(normalized)) {
    const c0 = normalized.charAt(0);
    const c1 = normalized.charAt(1);
    const c2 = normalized.charAt(2);
    rHex = c0 + c0;
    gHex = c1 + c1;
    bHex = c2 + c2;
  } else if (/^[0-9a-fA-F]{6}$/.test(normalized)) {
    rHex = normalized.slice(0, 2);
    gHex = normalized.slice(2, 4);
    bHex = normalized.slice(4, 6);
  }

  const r = parseInt(rHex, 16);
  const g = parseInt(gHex, 16);
  const b = parseInt(bHex, 16);
  return `rgba(${r},${g},${b},${a})`;
}

export const PALETTE = CATEGORICAL_PALETTE;


